<section *ngIf="currentMessage && formSubmitted">
  <div class="text-center img-block mt-5">
    <img
      src="assets/images/products/TravelInsurance.png"
      alt=""
      loading="lazy"
    />
  </div>
  <div class="text-center">
    <h4>{{ currentMessage }}</h4>
  </div>
</section>
<section
  *ngIf="!currentMessage && !formSubmitted"
  class="quotation-fields-container"
>
  <div class="p-4 grid-shadow1">
    <h4 class="quotation-field-header mb-3">
      Let's Get You A Customized Travel Insurance Plan
    </h4>
    <section class="my-5">
      <form [formGroup]="quotationFieldsForm">
        <div class="mb-4">
          <label class="field-label d-block mb-3"
            >{{ "travel_purpose" | translate }}
            <span class="text-red">*</span></label
          >
          <div class="btn-group" role="group" aria-label="Travel Purpose">
            <ng-container *ngFor="let travelPurpose of getTravelPurposeList">
              <input
                type="radio"
                class="btn-check"
                [id]="travelPurpose.masterDataID"
                [value]="travelPurpose.masterDataID"
                formControlName="travelPurpose"
              />
              <label
                class="btn rounded radio-outline-button me-2 px-2 px-md-5 py-2"
                [for]="travelPurpose.masterDataID"
                >{{ travelPurpose?.mdTitle }}</label
              >
            </ng-container>
          </div>
          <div
            *ngIf="submitted && quotationFieldsForm.get('travelPurpose')?.invalid && quotationFieldsForm.get('travelPurpose')?.errors?.['required']"
            class="text-red small"
          >
            {{ "travel_purpose_req" | translate }}
          </div>
        </div>

        <div class="">
          <label class="field-label"
            >{{ "travel_category" | translate }}
            <span class="text-red small">*</span></label
          >
          <div>
            <mat-radio-group formControlName="familyTypeID">
              <mat-radio-button
                *ngFor="let type of getTravelCategory"
                [value]="type.masterDataID"
              >
                {{ type.mdTitle }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div
            class="text-red small"
            *ngIf="submitted && quotationFieldsForm.get('familyTypeID')?.invalid && quotationFieldsForm.get('familyTypeID')?.errors?.['required']"
          >
            {{ "travel_cate_req" | translate }}
          </div>
        </div>
        <div
          class="disclaimer-box text-secondary small mb-3"
          *ngIf="
            quotationFieldsForm.get('familyTypeID')?.value ===
            familyCategoryMasterId
          "
        >
          <i class="fa fa-info-circle me-1" aria-hidden="true"></i>
          {{ "travel_category_disclaimer" | translate }}
        </div>

        <div class="mb-4">
          <label class="field-label"
            >{{ "travel_type" | translate }}
            <span class="text-red small">*</span></label
          >
          <mat-form-field class="w-100">
            <mat-select formControlName="travelTypeID">
              <mat-option
                *ngFor="let travelType of getTravelTypeList"
                [value]="travelType.masterDataID"
                >{{ travelType?.mdTitle | translate }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <div
            class="text-red small"
            *ngIf="submitted && quotationFieldsForm.get('travelTypeID')?.invalid && quotationFieldsForm.get('travelTypeID')?.errors?.['required']"
          >
            {{ "travel_type_req" | translate }}
          </div>
        </div>

        <div
          class="mb-2"
          [class.destination-area-uneditable]="
            quotationFieldsForm.get('travelTypeID')?.value ===
              INBOUND_TRAVEL_TYPE_MASTER_ID ||
            quotationFieldsForm.get('travelTypeID')?.value ===
              DOMESTIC_TRAVEL_TYPE_MASTER_ID
          "
        >
          <label class="field-label"
            >{{ "destinations" | translate }}
            <span class="text-red">*</span></label
          >
          <div class="">
            <mat-form-field class="example-chip-list w-100">
              <mat-chip-grid #chipGrid aria-label="Destination selection">
                <mat-chip-row
                  *ngFor="let destination of selectedDestinations"
                  (removed)="remove(destination)"
                >
                  {{ destination.ToCountryName }}
                  <button
                    matChipRemove
                    [attr.aria-label]="'remove ' + destination.ToCountryName"
                  >
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>

              <input
                #destinationInput
                (focus)="onFocus()"
                formControlName="destination"
                [matChipInputFor]="chipGrid"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="selected($event)"
              >
                <mat-option
                  *ngFor="let destination of filteredDestinations | async"
                  [value]="destination.TocountryID"
                >
                  {{ destination.ToCountryName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div
              *ngIf="submitted && selectedDestinations.length == 0"
              class="text-red small"
            >
              {{ "destination_req" | translate }}
            </div>
          </div>
        </div>

        <div
          class="mb-3"
          *ngIf="
            quotationFieldsForm.get('travelTypeID')?.value ===
            INBOUND_TRAVEL_TYPE_MASTER_ID
          "
        >
          <label class="field-label"
            >{{ "country_of_orgin" | translate }}
            <span class="text-red">*</span></label
          >
          <div class="">
            <mat-form-field class="w-100">
              <mat-select
                formControlName="countryOfOrigin"
                placeholder="{{ 'select_country_of_origin' | translate }}"
              >
                <mat-option
                  *ngFor="let country of getCountriesList"
                  [value]="country.TocountryID"
                >
                  {{ country.ToCountryName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div
              *ngIf="submitted && quotationFieldsForm.get('countryOfOrigin')?.invalid && quotationFieldsForm.get('countryOfOrigin')?.errors?.['required']"
              class="text-red small"
            >
              {{ "country_of_origin_req" | translate }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-2">
            <label class="field-label"
              >{{ "trip_start_date" | translate }}
              <span class="text-red">*</span></label
            >
            <mat-form-field class="w-100">
              <input
                matInput
                [matDatepicker]="tripStartDate"
                [min]="minTripStartDate"
                formControlName="tripStartDate"
                placeholder="DD/MM/YYYY"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="tripStartDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #tripStartDate></mat-datepicker>
            </mat-form-field>
            <div
              class="text-red small"
              *ngIf="submitted && quotationFieldsForm.get('tripStartDate')?.invalid && quotationFieldsForm.get('tripStartDate')?.errors?.['required']"
            >
              {{ "trip_start_date_req" | translate }}
            </div>
          </div>
          <div class="col-md-6 mb-2">
            <label class="field-label"
              >{{ "trip_end_date" | translate }}
              <span class="text-red">*</span></label
            >
            <mat-form-field class="w-100">
              <input
                matInput
                [matDatepicker]="tripEndDate"
                [min]="minTripEndDate"
                formControlName="tripEndDate"
                placeholder="DD/MM/YYYY"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="tripEndDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #tripEndDate></mat-datepicker>
            </mat-form-field>
            <div
              class="text-red small"
              *ngIf="submitted && quotationFieldsForm.get('tripEndDate')?.invalid && quotationFieldsForm.get('tripEndDate')?.errors?.['required']"
            >
              {{ "trip_end_req" | translate }}
            </div>
            <div
              class="text-red small"
              *ngIf="submitted && quotationFieldsForm.get('tripEndDate')?.invalid && quotationFieldsForm.get('tripEndDate')?.errors?.['maxTripDurationExceeded']"
            >
              {{ "converts_multiple_trip" | translate }}
            </div>
          </div>
        </div>

        <div
          class=""
          *ngIf="
            quotationFieldsForm.get('travelTypeID')?.value ==
            PILGRIMAGE_TRAVEL_PURPOSE_MASTER_ID
          "
        >
          <label class="field-label"
            >{{ "trip_duration" | translate }}
            <span class="text-red small">*</span></label
          >
          <div>
            <mat-radio-group formControlName="isDaysTrip">
              <mat-radio-button
                *ngFor="let type of durationTypes"
                [value]="type.value"
              >
                {{ type.name }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <!-- <div
            class="text-red small"
            *ngIf="submitted && quotationFieldsForm.get('isDaysTrip')?.invalid && quotationFieldsForm.get('familyTypeID')?.errors?.['required']"
          >
            {{ "travel_cate_req" | translate }}
          </div> -->
        </div>

        <div class="mb-2">
          <label class="field-label"
            >{{ "traveling_days" | translate }}
            <span class="text-red">*</span></label
          >
          <mat-form-field class="w-100 mat-form-field-sm">
            <input
              matInput
              type="text"
              (keydown)="numberOnly($event)"
              formControlName="travelingDays"
            />
          </mat-form-field>
          <div
            class="text-red small"
            *ngIf="submitted && quotationFieldsForm.get('travelingDays')?.invalid && quotationFieldsForm.get('travelingDays')?.errors?.['required']"
          >
            {{ "traveling_days_req" | translate }}
          </div>
        </div>

        <!-- <div class="mb-4">
                    <label class="field-label">{{'travel_insurance_option' | translate}}<span class="text-red small">*</span></label>
                    <div>
                      <mat-radio-group formControlName="uploadType" [ngClass]="{'uneditable': isEditMode}">
                        <mat-radio-button *ngFor="let flowType of flowTypeList" [value]="flowType.id">
                          {{ flowType.label }}
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <div class="text-red small" *ngIf="submitted && quotationFieldsForm.get('uploadType')?.invalid && quotationFieldsForm.get('uploadType')?.errors?.['required']">
                     {{'flow_type_req' | translate}}
                  </div>
                  </div> -->

        <ng-container>
          <div class="mb-2">
            <label class="field-label"
              >{{ "num_of_travelers" | translate }}
              <span class="text-red">*</span></label
            >
            <mat-form-field class="w-100 mat-form-field-sm">
              <input
                matInput
                formControlName="numberOfTravelers"
                (keydown)="numberOnly($event)"
                (blur)="numberOfTravelers()"
                 (paste)="$event.preventDefault()"
              />
            </mat-form-field>
            <div
              class="text-red small"
              *ngIf="submitted && quotationFieldsForm.get('numberOfTravelers')?.invalid && quotationFieldsForm.get('numberOfTravelers')?.errors?.['required']"
            >
              {{ "num_of_travelers_req" | translate }}
            </div>
            <div
              class="text-red small"
              *ngIf="quotationFieldsForm.get('numberOfTravelers')?.errors?.['maxTravelers']"
            >
              {{ "max_travellers" | translate }}
            </div>
          </div>
          <ng-container>
            <section formArrayName="travelersDetails">
              <div
                *ngFor="
                  let travelerDetail of getTravelersDetails.controls;
                  let i = index
                "
                [formGroupName]="i"
              >
                <div class="heading2">
                  {{ "traveler" | translate }} {{ i + 1 }}
                  <section class="example-section d-inline">
                    <mat-checkbox
                      formControlName="isProposerATraveller"
                      (change)="
                        onProposerChange(travelerDetail, $event.checked)
                      "
                      >{{ "is_the_proposer" | translate }}
                    </mat-checkbox>
                  </section>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="field-label"
                      >{{ "date_of_birth" | translate }}
                      <span class="text-red">*</span></label
                    >
                    <mat-form-field class="w-100">
                      <input
                        matInput
                        [matDatepicker]="picker"
                        [max]="dateOfBirthMaxDate"
                        formControlName="dateOfBirth"
                        placeholder="DD/MM/YYYY"
                        (dateChange)="dateOfBirthChange($event, i)"
                      />
                      <mat-datepicker-toggle
                        matIconSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker="matDatepicker"></mat-datepicker>
                    </mat-form-field>
                    <div
                      class="text-red small"
                      *ngIf="submitted && getTravelersDetails.at(i).get('dateOfBirth')?.invalid && getTravelersDetails.at(i).get('dateOfBirth')?.errors?.['required']"
                    >
                      {{ "date_of_birth_req" | translate }}
                    </div>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="field-label">{{ "age" | translate }}</label>
                    <mat-form-field class="w-100">
                      <input
                        matInput
                        type="text"
                        readonly
                        formControlName="age"
                        (keypress)="numberOnly($event)"
                      />
                    </mat-form-field>
                    <div
                      class="text-red small"
                      *ngIf="submitted && getTravelersDetails.at(i).get('age')?.errors?.['maxAge']"
                    >
                      {{ "age_max_error" | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                *ngIf="
                  getTravelersDetails.controls.length > 0 &&
                  submitted &&
                  getTravelersDetails.hasError('atLeastOneRequired')
                "
              >
                <span class="text-red small">{{
                  "at_least_one_purposer" | translate
                }}</span>
              </div>
              <div
                *ngIf="
                  getTravelersDetails.controls.length > 0 &&
                  submitted &&
                  getTravelersDetails.hasError('minAgeRequired')
                "
              >
                <span class="text-red small">{{
                  "at_least_one_traveler" | translate
                }}</span>
              </div>
              <div
                *ngIf="
                  getTravelersDetails.controls.length > 0 &&
                  getTravelersDetails.hasError('oldAgeRestriction')
                "
                class="form-text"
              >
                <p>
                  <b> We are sorry for the inconvenience!</b>
                  Unfortunately, due to age restrictions, we are unable to offer
                  a travel policy to individuals over 80 years old. We
                  understand this might be disappointing, and we’re here to help
                  with any questions or concerns you may have.
                </p>
                <p>
                  Feel free to reach out to us at
                  <a href="mailto:travel@kenindia.com">travel@kenindia.com</a>
                  or visit our office for further assistance. Thank you for your
                  understanding!
                </p>
              </div>
            </section>
          </ng-container>
        </ng-container>
        <div class="text-center mt-4 submit-button">
          <button
            class="primary-Button"
            (click)="submit()"
            [disabled]="getTravelersDetails.hasError('oldAgeRestriction')"
          >
            Get Quote <i class="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      </form>
    </section>
  </div>
</section>
